module.exports = __webpack_public_path__ + "icon.fd04d81a.svg";